module.exports = __webpack_public_path__ + "img/bf-bg-short.0955aab8.png";